import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'EmptyString',
  standalone: true
})
export class EmptyStringPipe implements PipeTransform {

   transform(value: any): string {
    if (value === null || value === undefined) {
        return '';
    }
    return value;
  }
}
